export default "__VITE_ASSET__c27c98d3__"